import HardPullApprovedScreen from 'features/lineOfCredit/screens/hardPullApproved/HardPullApprovedScreen';
import React from 'react';

export default function Page() {
  return <HardPullApprovedScreen />;
}
